/**
 * E5.4 step 2 (ARCHITECTURE §5.17): whether the planet's forest is drawn — the woods beyond the battle's own dressing,
 * from the forest function (core/forest.ts), in the renderer only: nothing of it is in the sim yet (no cover, no
 * obstacle, nothing to fell). A presentation flag, like the tree drawing's: read from `?forest=1` by the game; the Lab
 * sets the override before it launches (it starts the match in-page, with no URL to read). Off by default.
 */
let override: boolean | null = null;

/** The Lab's launch (null: back to the URL / the default). */
export function setForestDrawn(on: boolean | null): void { override = on; }

/** Whether the forest is drawn: the Lab's override, else the page's `?forest=1`, else off. */
export function forestDrawn(): boolean {
  if (override !== null) return override;
  try { return typeof location !== 'undefined' && new URLSearchParams(location.search).get('forest') === '1'; }
  catch { return false; }
}
